
import { defineComponent, ref } from 'vue'
import { register, signIn } from '@/services/auth'

export default defineComponent({
  name: 'AuthModal',
  props: {
    onSuccess: Function,
  },
  emits: ['close', 'success'],
  setup(props, { emit }) {
    const isLogin = ref(true)
    const account = ref('')
    const password = ref('')
    const registerEmail = ref('')
    const registerPassword = ref('')
    const loading = ref(false)
    const error = ref('')

    const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    const finish = () => {
      props.onSuccess?.()
      emit('success')
      emit('close')
    }

    const submitLogin = async () => {
      if (!account.value.trim() || !password.value) {
        error.value = '请输入邮箱和密码'
        return
      }
      loading.value = true
      error.value = ''
      const result = await signIn(account.value.trim().toLowerCase(), password.value)
      loading.value = false
      if (result.error) {
        error.value = result.error.message || '登录失败'
        return
      }
      finish()
    }

    const submitRegister = async () => {
      const email = registerEmail.value.trim().toLowerCase()
      if (!EMAIL_REGEX.test(email)) {
        error.value = '请输入有效的邮箱地址'
        return
      }
      if (registerPassword.value.length < 8) {
        error.value = '密码至少 8 位'
        return
      }
      loading.value = true
      error.value = ''
      const result = await register(email, registerPassword.value)
      loading.value = false
      if (result.error) {
        error.value = result.error.message || '注册失败'
        return
      }
      finish()
    }

    const toggleMode = () => {
      isLogin.value = !isLogin.value
      error.value = ''
    }

    return {
      account, emit, error, isLogin, loading, password,
      registerEmail, registerPassword, submitLogin, submitRegister, toggleMode,
    }
  },
})
